import { useState } from 'react';

export type ExamEventStatsPeriod = 'current-month' | 'last-3-months' | 'last-6-months' | number;

export default function useExamEventStatsSearchParams() {
  const [searchParams, setSearchParams] = useState<{
    period: ExamEventStatsPeriod;
  }>({
    period: 'current-month',
  });

  const changePeriod = (period: ExamEventStatsPeriod) => {
    setSearchParams({ period });
  };

  return [
    searchParams,
    {
      changePeriod,
    },
  ] as const;
}
